import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "roofBox"
const RoofBoxIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M18.331 11.255C18.928 11.303 19.441 11.703 19.633 12.275L20.54 15H22.5C22.5 15.78 21.906 16.419 21.146 16.492L22.5 18.522V22.5H21V18.977L19.849 17.25H3.915Q3.889 17.276 3.855 17.319C3.728 17.477 3.585 17.713 3.44 17.979 3.3 18.24 3.176 18.506 3.086 18.707Q3.034 18.822 3 18.902V22.5H1.5V18.604L1.555 18.468 1.56 18.457 1.567 18.439 1.6 18.36 1.718 18.09C1.818 17.87 1.958 17.573 2.12 17.27 2.265 17 2.442 16.704 2.632 16.452 1.982 16.288 1.5 15.702 1.5 15H3.719L3.786 14.788C4.029 13.994 4.254 13.042 4.389 12.435 4.542 11.75 5.15 11.25 5.862 11.25H18.211zM5.86 12.751 5.856 12.756 5.854 12.76C5.716 13.377 5.48 14.376 5.22 15.228Q5.138 15.495 5.048 15.75H19.21L18.21 12.75H5.86z"
            clipRule="evenodd"
          />
          <path d="M6 18.75C7.243 18.75 8.25 19.757 8.25 21H4.5V18.75zM19.5 21H15.75C15.75 19.757 16.757 18.75 18 18.75H19.5z" />
          <path
            fillRule="evenodd"
            d="M16.763 1.5C17.355 1.5 17.893 1.85 18.133 2.39L19.436 5.32 19.5 5.466V8.25C19.5 9.078 18.828 9.75 18 9.75H6C5.172 9.75 4.5 9.078 4.5 8.25V5.466L4.564 5.32 5.867 2.39C6.107 1.85 6.644 1.5 7.237 1.5zM6 8.25H18V6.375H6zM6.404 4.875H17.596L16.763 3H7.237z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default RoofBoxIcon
